<template>
  <div class="content">
    <van-list
      v-model:loading="state.loading"
      :finished="state.finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-cell
        v-for="(item, i) in state.getLists"
        :key="i + '-list'"
        :border="false"
      >
        <template #value>
          <p>领取{{ item.coupon_name }}</p>
          <p>
            领取时间：<span>{{ item.get_time }}</span>
          </p>
        </template>
      </van-cell>
    </van-list>
  </div>
</template>
<script setup>
import { useRouter } from "vue-router";
import { reactive } from "vue";
import { useStore } from "vuex";
import { monthCardCouponRecord } from "@/api/yzuser.js";
import { Toast } from "vant";
import { getQueryString } from "@/utils/location.js";

const router = useRouter();
const store = useStore();
const state = reactive({
  getLists: [],
  loading: false,
  finished: false,
});

var pagecode = 0;
const onLoad = () => {
  pagecode++;
  getCouponlog();
};

const getCouponlog = async () => {
  try {
    let res = await monthCardCouponRecord({
      uid: getQueryString("uid"),
      pagecode: pagecode,
    });
    if (res.data.code == 1) {
      state.getLists = state.getLists.concat(res.data.data.lists);
      if (pagecode >= res.data.data.total_page) {
        state.finished = true;
        return;
      }
    } else {
      Toast(res.data.msg);
      state.finished = true;
    }
    state.loading = false;
  } catch (error) {
    console.log(error);
  }
};
</script>
<style scoped>
.content {
  height: 87vh;
  overflow: auto;
  padding-bottom: 100px;
}
.van-cell {
  width: 686px;
  height: 134px;
  background: #fff;
  display: block;
  border-radius: 16px;
  padding: 24px;
  margin-bottom: 20px;
}
.van-cell p:nth-of-type(1) {
  font-size: 32px;
  color: #333;
  font-weight: bold;
  /* margin-bottom: 12px; */
}
.van-cell p:nth-of-type(2) {
  /* margin-top: 12px; */
  font-size: 24px;
  color: #707070;
}
</style>
